import { useLang, type Lang } from "@/i18n/i18n";
import { cn } from "./ui/cn";

const OPTIONS: { id: Lang; label: string; name: string }[] = [
  { id: "en", label: "EN", name: "English" },
  { id: "vi", label: "VI", name: "Tiếng Việt" },
];

/** EN | VI toggle. Labels stay in their own language so anyone can find their way back. */
export function LanguageSwitch({ className }: { className?: string }) {
  const { lang, setLang } = useLang();
  return (
    <div role="group" aria-label="Language / Ngôn ngữ" className={cn("flex rounded-md border border-border bg-surface-2 p-0.5", className)}>
      {OPTIONS.map((o) => (
        <button
          key={o.id}
          type="button"
          lang={o.id}
          aria-pressed={lang === o.id}
          aria-label={o.name}
          onClick={() => setLang(o.id)}
          className={cn("h-7 min-w-9 rounded px-2 text-xs font-semibold", lang === o.id ? "bg-surface text-fg shadow-sm" : "text-muted hover:text-fg")}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
